import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useState } from "react";
import { AlertTriangle, ChevronDown } from "lucide-react";
import { fmtDate } from "@/lib/constants";

export default function ScadenzeBanner() {
  const [expanded, setExpanded] = useState(false);
  const { data = [] } = useQuery({
    queryKey: ["scadenze"],
    queryFn: async () => (await api.get("/scadenze?giorni=30")).data,
  });

  if (!data.length) return null;

  return (
    <div
      data-testid="scadenze-alert-banner"
      className="mb-6 rounded-r-lg border-l-4 border-amber-500 bg-amber-50 p-4 shadow-sm gz-fade-up"
    >
      <button
        className="flex w-full items-center justify-between text-left"
        onClick={() => setExpanded((e) => !e)}
        data-testid="scadenze-banner-toggle"
      >
        <div className="flex items-center gap-3">
          <AlertTriangle className="h-5 w-5 shrink-0 text-amber-600" />
          <p className="text-sm font-semibold text-amber-900">
            {data.length} {data.length === 1 ? "scadenza" : "scadenze"} da gestire (entro 30 giorni)
          </p>
        </div>
        <ChevronDown className={`h-4 w-4 text-amber-700 transition-transform ${expanded ? "rotate-180" : ""}`} />
      </button>
      {expanded && (
        <ul className="mt-3 space-y-1.5 border-t border-amber-200 pt-3">
          {data.slice(0, 8).map((s, i) => (
            <li key={i} className="flex items-center justify-between text-sm text-amber-900">
              <span>
                <strong>{s.nome}</strong> — {s.tipo} ({fmtDate(s.data_scadenza)})
              </span>
              <span className={`font-semibold ${s.scaduto ? "text-red-700" : "text-amber-700"}`}>
                {s.scaduto ? `Scaduto da ${Math.abs(s.giorni)} gg` : `${s.giorni} gg`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
